var _rect, _path, _rect2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWatermarkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3091 23.2944C21.8146 25.7898 19.0807 27.4464 15.998 27.4464C11.3441 27.4464 7.4856 23.6709 7.4856 18.934C7.4856 15.728 8.85089 12.8145 10.4879 10.4733L23.3091 23.2944ZM23.9635 21.9424L11.3456 9.3245C13.5972 6.49021 15.998 4.74658 15.998 4.74658C15.998 4.74658 24.5105 10.9289 24.5105 18.934C24.5105 19.9957 24.3166 21.009 23.9635 21.9424Z",
    fill: "#6B57FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.12109,
    y: 8.31006,
    width: 2.36457,
    height: 28.3748,
    rx: 1.18228,
    transform: "rotate(-45 5.12109 8.31006)",
    fill: "#FFC933"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.887 25.0763C22.4362 24.5504 22.9157 23.9515 23.3093 23.2943L10.4882 10.4731C10.0538 11.0943 9.6386 11.7558 9.26294 12.4523L21.887 25.0763Z",
    fill: "#FF7A00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermarkIcon);
export default __webpack_public_path__ + "static/media/watermark-icon.cab023a4.svg";
export { ForwardRef as ReactComponent };